module.exports = __webpack_public_path__ + "mainassets/img/faq-5-a.5a796da0.svg";